module.exports = __webpack_public_path__ + "img/sansheng.3da3d98e.jpg";